<script lang="ts">
	//Components
	import TemplateThermostatController from './Templates/TemplateThermostatController.svelte';
	import TemplatePVSystemController from './Templates/TemplatePVSystemController.svelte';
	import VGroupComponents from './Components/VGroupComponents.svelte';
	import ValidateTemplate from './Templates/wizard/ValidateTemplate.svelte';
	import TemplateCoverController from './Templates/TemplateCoverController.svelte';
	import TemplateEVChargerController from './Templates/TemplateEVChargerController.svelte';
	//Helpers
	import { getVirtualTemplate } from 'src/helpers/virtual_helpers/template_helpers/virtual_template_helpers';
	//Types
	import type { Device } from 'src/types/Device';
	import type { VCInterfaceStatus } from 'src/types/VirtualComponents';
	import type { VirtualDeviceTemplate } from 'src/helpers/virtual_helpers/template_helpers/virtual_template_types';

	export let device: Device;
	export let statuses: VCInterfaceStatus[];
	export let virtualTemplate: VirtualDeviceTemplate;

	let template: VirtualDeviceTemplate;
	$: template = virtualTemplate || getVirtualTemplate(device);
</script>

{#if template?.type}
	<ValidateTemplate {template} {statuses} />
{/if}
{#if template?.type === 'cover' || template?.type === 'valve'}
	<TemplateCoverController {device} {statuses} />
{:else if template?.type === 'thermostat'}
	<TemplateThermostatController {device} {statuses} />
{:else if template?.type === 'pv_system'}
	<TemplatePVSystemController {statuses} />
{:else if template?.type === 'ev_charger'}
	<TemplateEVChargerController {device} {statuses} />
{:else}
	<VGroupComponents {device} />
{/if}
